let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("inzsN")).then(() => parcelRequire('1nwt7'));